import { datadogLogs } from '@datadog/browser-logs';
import { Cloud } from '@silbo/core';
import { useMutation } from '@tanstack/react-query';
import { useWithDurationLog } from '../../../../hooks/useWithDurationLog';

export const useAcknowledgeFareMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (result?: unknown, variables?: unknown, context?: unknown) => void;
  onError?: (err?: unknown, variables?: unknown) => void;
}) => {
  const { mutateAsync, isError, isPending, isSuccess, error, reset } = useMutation({
    mutationFn: (fareId: string) => {
      datadogLogs.logger.debug('TANSTACK_DEBUG: TanStack Query executing acknowledgeFare mutation', {
        fareId,
        timestamp: Date.now(),
        source: 'tanstack-query',
      });
      return Cloud.acknowledgeFareAssignation({ fareId });
    },
    onSuccess,
    onError: (err, variables) => {
      datadogLogs.logger.error('TANSTACK_DEBUG: TanStack Query acknowledgeFare failed', {
        fareId: variables,
        error: err,
        errorMessage: err instanceof Error ? err.message : 'Unknown error',
        timestamp: Date.now(),
        source: 'tanstack-query',
      });
      if (onError) {
        onError(err, variables);
      }
      datadogLogs.logger.error('fare-acknowledge-error', err);
    },
    networkMode: 'online',
  });

  const acknowledgeFare = useWithDurationLog(mutateAsync, 'acknowledge-fare-duration');

  return { acknowledgeFare, isError, isPending, isSuccess, error, reset };
};
